import { APP_TIMEZONE, parseApiDateTime, EMPTY_FALLBACK } from "./date";

export const displayISODate = (isoDate: string): string => {
  return isoDate.split("T")[0];
};

export const displayLastUpdated = (lastUpdateISOString: string) => {
  const lastUpdateDate = parseApiDateTime(lastUpdateISOString);
  if (Number.isNaN(lastUpdateDate.getTime())) {
    return EMPTY_FALLBACK;
  }

  const datePart = lastUpdateDate.toLocaleDateString("en-US", {
    timeZone: APP_TIMEZONE,
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  const timePart = lastUpdateDate.toLocaleTimeString("en-US", {
    timeZone: APP_TIMEZONE,
  });
  return `${datePart} at ${timePart}`;
};

export const displayCurrencyAmount = (
  amount: number,
  currency: string,
): string => {
  const currencyUpper = currency.toUpperCase();
  let currencyDisplay = currencyUpper;
  if (currencyUpper === "ILS" || currencyUpper === "NIS") {
    currencyDisplay = "₪";
  } else if (currencyUpper === "USD") {
    currencyDisplay = "$";
  } else if (currencyUpper === "EUR") {
    currencyDisplay = "€";
  }
  const amountDisplay = amount.toLocaleString(undefined, {
    maximumFractionDigits: 2,
  });
  if (currencyDisplay === currencyUpper) {
    return `${amountDisplay} ${currencyDisplay}`;
  }
  return `${currencyDisplay}${amountDisplay}`;
};

export const displayIntentionStatus = (status: string) => {
  switch (status) {
    case "Approved":
      return "Approved";
    case "Unresolved":
      return "Unresolved";
    case "No_reply":
      return "No Reply";
    case "In_progress":
      return "In Progress";
    case "Needs_attention":
      return "Needs Attention";
    default:
      break;
  }
};
